export default [
  {
    field: 'firstName',
    headerName: 'First Name',
    type: 'text',
    width: 100,
    flex: 1,
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    type: 'text',
    width: 100,
    flex: 1,
  },
  {
    field: 'userType',
    headerName: 'Type',
    type: 'multiple-choice',
    flex: 1,
    valueFormatter: ({ value }) => (value && value[0].toUpperCase() + value.slice(1)) || '',
  },
  {
    field: 'emailAddress',
    headerName: 'Email Address',
    type: 'text',
    flex: 1,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    type: 'text',
    flex: 1,
    valueGetter: (params) => {
      const { phoneNumberPrefix, phoneNumber } = params.row;
      const { value, id } = phoneNumberPrefix ?? {};

      return value && id && phoneNumber
        ? `(${id}) ${value} ${phoneNumber}`
        : '';
    },
  },
];
